module.exports = __webpack_public_path__ + "img/logo-stowy.d60be946.png";